import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { getRequest, postRequest } from "../../globalhelper/helper";
import { useDispatch, useSelector } from "react-redux";
import { navUrl, showAlert } from "../../redux/Common/commonActions";
import moment from "moment";
import _ from "lodash";
import { externals } from "../../config.json";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Box,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DatePicker } from "@mui/x-date-pickers";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { CSVLink } from "react-csv";
import { GetApp } from "@material-ui/icons";
import { Cloud } from "@mui/icons-material";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const [previousCount, setPreviousCount] = useState(count);

  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0);
    }
    setPreviousCount(count);
  }, [count, page, onPageChange, previousCount]);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const DocumentTypes = ["Supplier Bill", "Transporter Bill"];
function Upload4() {
  const [ThemeNames, setthemeNames] = useState([]);
  const [TransactionType, setTransactionType] = useState("");
  const [DocumentType, setDocumentType] = useState("");
  const [ThemeName, setThemeName] = useState("");
  const [AllCompanies, setAllCompanies] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [Companies, setCompanies] = useState([]);
  const [Company, setCompany] = useState("");
  const [GSTINs, setGSTINs] = useState([]);
  const [GSTIN, setGSTIN] = useState("");
  const [From, setFrom] = useState("");
  const [To, setTo] = useState("");
  const [AllRecentHistory, setAllRecentHistory] = useState([]);
  const [RecentHistory, setRecentHistory] = useState([]);
  const [FNSError, setFNSError] = useState("");
  const state = useSelector((state) => state);
  const [TransactionTypes, setTransactionTypes] = useState([]);
  const Vendors = [
    { VendorName: "M&C SAATCHI MOBILE INDIA LLP", VendorID: "VM0000000030" },
  ];
  const [vendor, setVendor] = useState({});
  const dispatch = useDispatch();

  const navPage = (url) => {
    dispatch(navUrl(url));
  };
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(({ res }) => {
        setCompanies(
          (res.data || []).sort((a, b) =>
            (a.orgname || "").localeCompare(b.orgname || "")
          )
        );
        setAllCompanies(
          (res.data || []).sort((a, b) =>
            (a.orgname || "").localeCompare(b.orgname || "")
          )
        );
      })
      .catch(setErrorMessage);
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFrom(firstDay);
    setTo(lastDay);
  }, []);
  useEffect(() => {
    postRequest("api/transactions/getTransactions").then((resp) => {
      if (resp.type === "success") {
        const DATA = JSON.parse(resp.res.data);
        console.log(DATA);
        const sortedRows = DATA.sort((a, b) => {
          const dateA = a.Start
            ? a.Start / 1000000
            : new Date(a.Created_At).getTime();
          const dateB = b.Start
            ? b.Start / 1000000
            : new Date(b.Created_At).getTime();
          return dateB - dateA;
        });
        setAllRecentHistory(sortedRows);
        setRecentHistory(sortedRows);
      }
    });
  }, []);

  const updateCompany = (val) => {
    setCompany(val);
    console.log(RecentHistory.length);

    postRequest("api/upload/uploadV4Credentials", {
      orgid: val?.orgid || "",
    }).then((response) => {
      const result = response.res?.data;
      if (!result) return;
      setTransactionType("");
      setTransactionTypes(result.transactionTypes || []);
      console.log(result.transactionTypes);

      setThemeName("");
    });
    if (TransactionType === "InstructorInvoice") {
      let GSTIN = [];
      AllCompanies.map((each) => {
        if (each.orgid === Company?.orgid) {
          GSTIN.push(each.GSTIN);
        }
      });
      setGSTINs(GSTIN);
    }
  };

  const updateTT = (val) => {
    console.log(val);

    setTransactionType(val);
    postRequest("api/upload/uploadV4Credentials", {
      orgid: Company?.orgid || "",
      transactionType: val,
    }).then((response) => {
      const result = response.res?.data;
      if (!result) return;
      setthemeNames(result.themename || []);
    });

    if (val === "InstructorInvoice") {
      let GSTIN = [];
      AllCompanies.map((each) => {
        if (each.orgid === Company?.orgid) {
          GSTIN.push(each.GSTIN);
        }
      });
      setGSTINs(GSTIN);
    }
  };

  useEffect(() => {
    if (AllRecentHistory.length) {
      setPage(0);
      let filteredData = [...AllRecentHistory];
      if (Company) {
        filteredData = filteredData.filter(
          (each) => each["OrgId"] === Company?.orgid
        );
      }
      if (TransactionType) {
        filteredData = filteredData.filter(
          (each) => each["TransactionType"] === TransactionType
        );
      }
      if (ThemeName) {
        filteredData = filteredData.filter(
          (each) => each["ThemeName"] === ThemeName
        );
      }

      setRecentHistory(filteredData);
    }
  }, [Company, TransactionType, ThemeName, AllRecentHistory]);

  const fileInputOnChange = async (e) => {
    const { MAX_TOTAL_SIZE } = externals;
    if (
      (localStorage.getItem("tenant_id") === "DM00005" ||
        localStorage.getItem("tenant_id") === "TID00003") &&
      (TransactionType === "PurchaseOrder" || TransactionType === "CostSheet")
    ) {
      const formData = new FormData();
      const files = e.target.files;

      Array.from(files).forEach((file) => {
        formData.append("files", file);
      });

      var currentDate = moment();
      var RecivedDate = currentDate.format("YYYY-MM-DD");
      formData.append("RecivedDate", RecivedDate || "");
      formData.append("TransactionType", TransactionType || "");
      formData.append("ForPrdFrom", From || "");
      formData.append("ForPrdTo", To || "");
      formData.append("ThemeName", ThemeName || "");
      formData.append("VendorName", vendor.VendorName || "");
      formData.append("VendorID", vendor.VendorID || "");
      try {
        const response = await postRequest(
          `api/upload/UploadForRecon?OrgID=${Company?.orgid || ""
          }&TransactionType=${TransactionType || ""}&ThemeName=${ThemeName || ""
          }`,
          formData
        );
        console.log("Upload Success:", response);
      } catch (error) {
        console.error("Upload Error:", error);
      }
    } else {
      let file = e.target.files[0];
      console.log(TransactionType);

      let additionalParam =
        TransactionType === "Journal"
          ? "SA"
          : TransactionType === "Connections"
            ? "CONX"
            : TransactionType === "EmployeeCost"
              ? "EC"
              : TransactionType === "BankStatements"
                ? "BS"
                : TransactionType === "InternalPlan"
                  ? "PE"
                  : [
                    "GRN",
                    "InstructorCostAccrual",
                    "InstructorInvoice",
                    "PettyCash",
                  ].includes(TransactionType)
                    ? "BT3I"
                    : "BT3I";
      if (file && file.size <= Number(MAX_TOTAL_SIZE)) {
        if (
          (file.name.endsWith(".xls") && TransactionType === "Collection") ||
          (file.name.endsWith(".xls") && TransactionType === "sales")
        ) {
          setFNSError(
            ".xls Extention is not supported for selected transaction type"
          );
        } else {
          setFNSError("");
          const formData = new FormData();
          formData.append("file", file);

          const encodedThemeName = encodeURIComponent(ThemeName);

          console.log(encodedThemeName); // Output: G%26SRNIV1
          postRequest(
            `api/upload/singleUpload2?OrgID=${Company?.orgid || ""}&TransactionType=${TransactionType}&ThemeName=${encodedThemeName}&GSTIN=${GSTIN}&From=${From}&To=${To}&ProcessCode=${additionalParam}&DocType=${DocumentType}`,
            formData
          ).then((res) => {
            console.log(res);
          });
        }
      } else if (
        (file.name.includes("pdf") ||
          file.name.includes("xlsx") ||
          file.name.includes("csv")) &&
        Number(MAX_TOTAL_SIZE) <= file.size
      ) {
        setFNSError(
          `The total size of all files must not exceed 50 MB. Currently: ${(
            file.size /
            (1024 * 1024)
          ).toFixed(2)} MB`
        );
      } else {
        setFNSError("File extension is mismatching");
      }
    }
    e.target.value = null;
  };
  const downloadCSV = () => {
    if (!Company || !TransactionType || !ThemeName) {
      console.error(
        "All dropdowns must be selected before downloading the file."
      );
      return;
    }

    postRequest(
      `api/upload/getcsv?OrgID=${Company?.orgid || ""}&TransactionType=${TransactionType}&ThemeName=${ThemeName}`,
      {
        responseType: "json",
      }
    )
      .then((res) => {
        if (
          res?.res?.data?.type === "Buffer" &&
          Array.isArray(res.res.data.data)
        ) {
          const byteArray = new Uint8Array(res.res.data.data);

          const contentType =
            res?.res?.headers?.["content-type"] || "application/octet-stream";

          const fileExtensionMap = {
            "text/csv": ".csv",
            "application/pdf": ".pdf",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
              ".xlsx",
            "application/zip": ".zip",
          };

          const extension = fileExtensionMap[contentType] || ".csv";

          const blob = new Blob([byteArray], { type: contentType });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = `${ThemeName}${extension}`;
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          console.error("Invalid file data structure:", res.res.data);
        }
      })
      .catch((err) => {
        console.error("Error downloading file:", err);
      });
  };

  const downloadICFile = async (TransID, TransactionType, ThemeName) => {
    try {
      if (!Company || !TransactionType || !ThemeName) {
        dispatch(showAlert("All dropdowns must be selected before downloading the file."
          , "error"));
        return;
      }
      const response = await postRequest(
        `api/upload/getICFile?OrgID=${Company?.orgid || ""}&TransactionType=${TransactionType}&ThemeName=${ThemeName}&TransID=${TransID}`,
        { responseType: "json" }
      );

      if (
        response?.res?.data?.data?.type === "Buffer" &&
        Array.isArray(response?.res?.data?.data?.data)
      ) {
        console.log(response?.res?.data?.extension)
        const byteArray = new Uint8Array(response.res.data.data.data);
        const contentType =
          response?.res?.headers?.["content-type"] ||
          "application/octet-stream";
        const fileExtensionMap = {
          "text/csv": ".csv",
          "application/pdf": ".pdf",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            ".xlsx",
          "application/zip": ".zip",
        };
        const extension = response?.res?.data?.extension || fileExtensionMap[contentType] || ".csv";

        const blob = new Blob([byteArray], { type: contentType });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${TransID}${extension}`;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setErrorMessage("");
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessMessage("");
  };

  const refreshRow = (transaction, OrgId, tansactiontype) => {
    postRequest(
      `api/upload/refreshTransaction?OrgID=${OrgId}&TransactionId=${transaction}&TransactionType=${tansactiontype}`
    ).then((res) => {
      if (res.type === "success") {
        window.location.reload();
      }
    });
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Avoid a layout jump when reaching the last page with empty RecentHistory.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - RecentHistory.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const toggleReadMore = (rowIndex) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowIndex]: !prev[rowIndex],
    }));
  };

  const [expandedRows, setExpandedRows] = useState({});
  return (
    <Box>
      <Snackbar
        open={Boolean(errorMessage)}
        onClose={handleErrorClose}
        autoHideDuration={6000}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <Alert severity="error" onClose={handleErrorClose}>
          {errorMessage.toString()}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Boolean(successMessage)}
        onClose={handleSuccessClose}
        autoHideDuration={6000}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <Alert severity="success" onClose={handleSuccessClose}>
          {successMessage}
        </Alert>
      </Snackbar>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2}>
            <Grid item xs={3}>
              <Autocomplete
                size="small"
                fullWidth
                value={Company || null}
                options={Companies}
                getOptionLabel={(option) => option?.orgname || ""}
                isOptionEqualToValue={(option, value) =>
                  option.orgid === value?.orgid
                }
                onChange={(event, newValue) => updateCompany(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Company"
                    variant="outlined"
                    name="Company"
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Autocomplete
                size="small"
                fullWidth
                value={TransactionType || null}
                options={TransactionTypes}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => updateTT(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Transaction Type"
                    variant="outlined"
                    name="TransactionType"
                  />
                )}
              />
            </Grid>
            {(!TransactionType || TransactionType !== "BILL") && (
              <Grid item xs={3}>
                <Autocomplete
                  size="small"
                  fullWidth
                  value={ThemeName || null}
                  options={ThemeNames}
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => setThemeName(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Theme Name"
                      variant="outlined"
                      name="ThemeName"
                    />
                  )}
                />
              </Grid>
            )}
            {Company && TransactionType && ThemeName && (
              <Grid item xs={2}>
                <Button
                  variant="contained"
                  color="success"
                  onClick={downloadCSV}
                >
                  Download Theme
                </Button>
              </Grid>
            )}
          </Grid>
          <Grid container gap={2} marginTop={4}>
            {Company?.orgid === "OM0000000002" ? (
              <Grid item xs={3}>
                <Autocomplete
                  size="small"
                  fullWidth
                  value={vendor || null}
                  options={Vendors}
                  getOptionLabel={(option) => option?.VendorName || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.VendorID === value?.VendorID
                  }
                  onChange={(event, newValue) => setVendor(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Vendor"
                      variant="outlined"
                      name="Vendor"
                    />
                  )}
                />
              </Grid>
            ) : (
              ""
            )}

            {TransactionType === "InstructorInvoice" ? (
              <Grid item xs={3}>
                <Autocomplete
                  size="small"
                  fullWidth
                  value={GSTIN || null}
                  options={GSTINs}
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => setGSTIN(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="GSTIN"
                      variant="outlined"
                      name="GSTIN"
                    />
                  )}
                />
              </Grid>
            ) : TransactionType === "InstructorCostAccrual" ||
              !TransactionType ? null : TransactionType === "BILL" ? (
                <Grid item xs={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    value={DocumentType || null}
                    options={DocumentTypes}
                    getOptionLabel={(option) => option}
                    onChange={(event, newValue) => setDocumentType(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Doc Type"
                        variant="outlined"
                        name="DocType"
                      />
                    )}
                  />
                </Grid>
              ) : (
              <>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="ForPrdFrom"
                      value={From}
                      views={["day", "month", "year"]}
                      onChange={(newValue) => {
                        setFrom(newValue.format("YYYY-MM-DD"));
                      }}
                      renderInput={(params) => (
                        <TextField fullWidth size="small" {...params} />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="ForPrdTo"
                      value={To}
                      views={["day", "month", "year"]}
                      onChange={(newValue) => {
                        setTo(newValue.format("YYYY-MM-DD"));
                      }}
                      renderInput={(params) => (
                        <TextField fullWidth size="small" {...params} />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </>
            )}
            {Company?.orgid && (
              <Grid item xs={2}>
                <Button
                  disabled={
                    !Company ||
                    !TransactionType ||
                    (!ThemeName && TransactionType !== "BILL") ||
                    !From ||
                    !To ||
                    (TransactionType === "InstructorInvoice" && !GSTIN)
                  }
                  component="label"
                  variant="contained"
                  startIcon={<Cloud UploadIcon />}
                >
                  Upload file
                  <VisuallyHiddenInput
                    multiple
                    type="file"
                    onChange={fileInputOnChange}
                  />
                </Button>
                &nbsp;
                <small style={{ color: "red" }}>{FNSError}</small>
              </Grid>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
      {RecentHistory.length > 0 && Company?.orgid ? (
        <>
          <Box
            align="right"
            sx={{
              m: 2,
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              gap: 2,
            }}
          >
            <>
              <Pagination
                count={Math.ceil(RecentHistory.length / rowsPerPage)}
                page={page + 1}
                onChange={(event, newPage) => {
                  handleChangePage(event, newPage - 1);
                }}
                variant="outlined"
                shape="rounded"
                showFirstButton
                showLastButton
              />
              &nbsp;
              <CSVLink
                size="sm"
                filename={`uploadV4_${moment().format(
                  "YYYY-MM-DD_HH-mm-ss"
                )}.csv`}
                data={RecentHistory}
              >
                <Button variant="contained" color="success">
                  <GetApp />
                </Button>
              </CSVLink>
            </>
          </Box>
          <Grid container>
            <Grid item mb={2} mt={2}>
              <Typography variant="h6">Recently Uploaded</Typography>
            </Grid>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    {TransactionType === "Collections" ||
                      TransactionType === "Sales" ? (
                      ""
                    ) : (
                      <TableCell>Refresh</TableCell>
                    )}
                    <TableCell>Date & Time</TableCell>
                    <TableCell>TransactionID</TableCell>
                    <TableCell>TransactionType</TableCell>
                    <TableCell>ThemeName</TableCell>
                    <TableCell>ForPrdFrom</TableCell>
                    <TableCell>ForPrdTo</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Attachment</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? RecentHistory.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    : RecentHistory
                  ).map((item, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {TransactionType === "Collections" ||
                        TransactionType === "Sales" ? (
                        ""
                      ) : (
                        <TableCell>
                          <IconButton
                            color="primary"
                            onClick={() =>
                              refreshRow(
                                item["TransactionID"],
                                item["OrgId"],
                                item["TransactionType"]
                              )
                            }
                          >
                            <RefreshIcon />
                          </IconButton>
                        </TableCell>
                      )}
                      <TableCell>
                        {item.Start
                          ? moment(item.Start / 1000000).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )
                          : item.Created_At}
                      </TableCell>

                      <TableCell>{item["TransactionID"]}</TableCell>
                      <TableCell>{item["TransactionType"]}</TableCell>
                      <TableCell>{item["ThemeName"]}</TableCell>
                      <TableCell>{item["ForPrdFrom"]}</TableCell>
                      <TableCell>{item["ForPrdTo"]}</TableCell>
                      <TableCell sx={{ width: "20rem" }}>
                        <Typography
                          variant="body2"
                          noWrap={!expandedRows[rowIndex]}
                          style={{
                            width: "20rem",
                            whiteSpace: "wrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: expandedRows[rowIndex]
                              ? "block"
                              : "-webkit-box",
                            WebkitLineClamp: expandedRows[rowIndex]
                              ? "unset"
                              : 1,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {item["Status"]}
                        </Typography>
                        {item["Status"] && item["Status"].length > 40 ? (
                          <Button
                            size="small"
                            onClick={() => toggleReadMore(rowIndex)}
                            style={{ marginTop: "8px" }}
                          >
                            {expandedRows[rowIndex] ? `Read Less` : `Read More`}
                          </Button>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="text"
                          color="success"
                          disabled={!item.Data_Key}
                          onClick={() =>
                            downloadICFile(
                              item.TransactionID,
                              item.TransactionType,
                              item.ThemeName
                            )
                          }
                        >
                          <GetAppIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </>
      ) : (
        ""
      )}
    </Box>
  );
}
export default Upload4;